import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-section07',
    templateUrl: './section07.component.html',
    styleUrls: ['./section07.component.scss']
})

export class Section07Component implements OnInit {
    @Input() data;

    constructor() {
    }

    ngOnInit() {
    }
}
